export { CellProps } from "react-table";
export * from "./DynamicTable";
export * from "./Table";
export * from "./TableBody";
export * from "./TableCell";
export * from "./TableHead";
export * from "./TableHeaderCell";
export * from "./TableHeaderRow";
export * from "./TablePagination";
export * from "./TableRow";
//# sourceMappingURL=index.js.map